import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PostService } from "./post.service";

@Injectable({
  providedIn: "root",
})
export class BoothDataService {
  place_id: any;
  boothList: any;
  filterbooths: any[];
  boothDetails: any;
  constructor(
    private httpClient: HttpClient,
    private postService: PostService
  ) {}

  storeBoothData(booth_data, place_id) {
    this.boothList = booth_data;
    this.place_id = place_id;
  }
  checkBoothData(place_data) {
    if (this.place_id == place_data) {
      return this.boothList;
    } else {
      return;
    }
  }
  // storeBoothData(booth_data) {
  //   this.boothList = booth_data;
  // }
  // checkBoothData() {
  //   return this.boothList;
  // }
  storeBoothDetails(booth_details) {
    this.boothDetails = booth_details;
  }

  checkBoothDetails() {
    return this.boothDetails;
  }
  // getPlaceId(place_id) {
  //   this.place_id = place_id;
  // }

  // fetchData(page: number = 1): Observable<any[]> {
  //   // const url = `${environment.GET_DONATION_DETAILS}?elc=7&limit=10&page=${page}`;
  //   // return this.httpClient.get<any[]>(url);
  //   const url = `${environment.API_GET_BOOTHS}?elc=7&group_id=5&place_id=${this.place_id}&limit=10&page=${page}`;
  //   return this.httpClient.get<[]>(url);
  // }
}
